import {gql, Query} from 'apollo-angular';
import { companyBaseFragment} from './fragments/company-base.fragments';
import { companyDataFragment } from './fragments/company-data.fragment';
import { Injectable } from '@angular/core';
import { addressFragment } from '../common/fragments/address.fragment';
import { contactFragment } from '../common/fragments/contact.fragment';
import { categoryBaseFragment } from '../categories/fragments/category-base.fragments';
import { ICompany } from '@collections/companies/interfaces/company.interface';


export interface CompanyBySlugResponse {
  companyBySlug: ICompany;
}

@Injectable({
  providedIn: 'root'
})
export class CompanyBySlugGQL extends Query<CompanyBySlugResponse> {
  document = gql`
  query getCompanyBySlug (
    $slug:String!,
    $lang: String!,
    $category: String){
      companyBySlug(slug:$slug, lang: $lang) {
          ...companyBase
          ...companyData
          folder
          companyImage
          shortDescription
          description
          categories(lang: $lang, thirdLevel: true) {
            ...categoryBase
            parent(lang: $lang) {
              ...categoryBase
            }
          }
          tags(lang: $lang) {
            tag
          }
          fieldsOfRelevance
          materials
          translations
          associatedCount
          productsCount
          newsCount
          primaryPathLocales {
            path
            lang
          }
          addresses {...AddressFields}
          contacts {...ContactFields}
          webSite
          socials {
            name
            url
          }
          associations(lang: $lang) {
            ...companyBase
          }
          nextCompany(lang: $lang, category: $category) {
            ...companyBase
          }
          prevCompany(lang: $lang, category: $category) {
            ...companyBase
          }
      }
  }
  ${companyBaseFragment},
  ${companyDataFragment},
  ${contactFragment},
  ${addressFragment},
  ${categoryBaseFragment}
  `;
}
